<template>
  <PageErreurMinerve :erreur="erreur">
    <template v-if="detail" #texte>
      <p>{{ erreur.texte }}</p>
      <p class="error-detail">
        Message d'erreur :
        <span class="error-code">{{ detail }}</span>
      </p>
    </template>
    <template #actions>
      <button v-focus class="btn-primary" @click="refresh">
        {{ erreur.cta }}
      </button>
      <button v-if="erreur.cta2" v-focus class="btn-secondary" @click="suite">
        {{ erreur.cta2 }}
      </button>
    </template>
  </PageErreurMinerve>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import PageErreurMinerve from "@follaw-fr/components/reusable/minerve/PageErreurMinerve.vue";
import {
  erreurPourStatut,
  statutDecrit,
} from "@follaw-fr/components/reusable/minerve/erreursMinerve";

const props = defineProps({
  error: {
    type: Object,
    default: () => {
      return { status: 404, message: "Page non trouvée" };
    },
  },
});

const router = useRouter();

// La charte décrit 404, 500 et 403. Tout autre statut garde la Minerve de la 500 mais n'invente pas
// « Erreur 500 » : le code réel s'affiche s'il existe, sinon aucun, et sans statut le message du
// produit remplace l'explication générique.
const sansStatut = computed(() => !props.error.status);
const erreur = computed(() => {
  const base = erreurPourStatut(props.error.status);
  if (statutDecrit(props.error.status)) return base;
  const code = sansStatut.value ? "" : `Erreur ${props.error.status}`;
  const texte =
    sansStatut.value && props.error.message ? props.error.message : base.texte;
  return { ...base, code, texte };
});
const detail = computed(() =>
  Number(props.error.status) === 404 || sansStatut.value
    ? ""
    : props.error.message
);

function refresh() {
  router.go();
}

// Deuxième bouton : retour à l'accueil sur la 404, chat de support sur l'erreur générique.
function suite() {
  if (Number(props.error.status) === 404) {
    router.push("/");
  } else {
    window.$crisp?.push(["do", "chat:open"]);
  }
}
</script>

<style scoped lang="scss">
.error-detail {
  margin-top: 8px;
  font-weight: 600;
}
</style>
